import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ModalContentItem } from './ModalContentItem';
import { ButtonNext, ButtonPrev, IconChevron, ModalWrapper, DesktopControlsWrapper } from './styles';
import { goToNextItem, goToPreviousItem } from './utils';
export var ModalContentList = function (_a) {
  var modalContentList = _a.modalContentList,
    events = _a.events,
    _b = _a.size,
    cardSize = _b === void 0 ? 'medium' : _b,
    fullscreenBgColor = _a.fullscreenBgColor,
    _c = _a.startingModalContentItem,
    startingModalContentItem = _c === void 0 ? 0 : _c,
    containerPosition = _a.containerPosition;
  var _d = useState(startingModalContentItem),
    activeItem = _d[0],
    setActiveItem = _d[1];
  useEffect(function () {
    if (events && events.onItemActive) {
      events.onItemActive(activeItem);
    }
  }, [events && events.onItemActive ? activeItem : null]);
  var refModalWrapper = useRef(null);
  var _e = useState(),
    modalWrapperElement = _e[0],
    setModalWrapperElement = _e[1];
  useEffect(function () {
    if (refModalWrapper.current) {
      setModalWrapperElement(refModalWrapper.current.children[0]);
    }
  }, []);
  var showDesktopControls = containerPosition === 'top' || containerPosition === 'center' || containerPosition === 'bottom';
  return _jsxs("div", {
    children: [_jsx("div", {
      ref: refModalWrapper,
      children: _jsx(ModalWrapper, {
        cardSize: cardSize,
        "data-cy-label": "modal",
        children: modalContentList.length > 0 && modalContentList.map(function (modalContentItem, index) {
          return _jsx(ModalContentItem, {
            visible: activeItem === index,
            modalContentItem: modalContentItem,
            size: cardSize,
            events: events,
            modalContentList: modalContentList,
            activeItem: activeItem,
            setActiveItem: setActiveItem,
            fullscreenBgColor: fullscreenBgColor,
            modalWrapperElement: modalWrapperElement
          }, index);
        })
      })
    }), showDesktopControls && _jsxs(DesktopControlsWrapper, {
      children: [activeItem > 0 && _jsx(ButtonPrev, {
        onClick: function () {
          return goToPreviousItem({
            activeItem: activeItem,
            setActiveItem: setActiveItem,
            onItemPrev: events === null || events === void 0 ? void 0 : events.onItemPrev,
            modalWrapperElement: modalWrapperElement
          });
        },
        cardSize: cardSize,
        children: _jsx(IconChevron, {
          size: 18,
          type: "icon-chevron-left-big"
        })
      }), activeItem < modalContentList.length - 1 && _jsx(ButtonNext, {
        onClick: function () {
          return goToNextItem({
            activeItem: activeItem,
            setActiveItem: setActiveItem,
            onItemNext: events === null || events === void 0 ? void 0 : events.onItemNext,
            modalWrapperElement: modalWrapperElement,
            modalContentList: modalContentList
          });
        },
        cardSize: cardSize,
        children: _jsx(IconChevron, {
          size: 18,
          type: "icon-chevron-right-big"
        })
      })]
    })]
  });
};